import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarSquareRegularTypeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.2 4q1.1 0 1.2 1.2v2H24c1.8 0 3.2 1.4 3.2 3.2v14.4c0 1.8-1.4 3.2-3.2 3.2H8a3 3 0 0 1-3.2-3.2V10.4c0-1.8 1.4-3.2 3.2-3.2h1.6v-2a1.2 1.2 0 1 1 2.4 0v2h8v-2q0-1.1 1.2-1.2M8 9.6q-.7.1-.8.8v14.4q.1.7.8.8h16q.7-.1.8-.8V10.4q-.1-.7-.8-.8zm10.7 1.8q1.1 0 1.2 1.2v1.1H21q1.1 0 1.2 1.2 0 1-1.2 1.2H20v3H21q1.1.2 1.2 1.2 0 1.1-1.2 1.2H20v1.1a1.2 1.2 0 1 1-2.4 0v-1.1h-3v1.1a1.2 1.2 0 1 1-2.4 0v-1.1H11a1.2 1.2 0 1 1 0-2.4H12v-3H11a1.2 1.2 0 1 1 0-2.4H12v-1.1q0-1.1 1.2-1.2 1 0 1.2 1.2v1.1h3v-1.1q.2-1.1 1.2-1.2m-4.2 4.7v3h3v-3z" })
});
export default SvgCalendarSquareRegularTypeIcon;
